import { useContext } from 'react'

import { TextInput } from '@mantine/core'

import { useAuth } from 'src/auth'
import Tag from 'src/components/DataDisplay/Tag/Tag'
import FilterMenu from 'src/components/Overlays/FiltersMenu/FilterMenu'
import { RecruitersContext } from 'src/context/RecruitersContext'
import { TaskPriority, TaskStatus, TaskType } from 'src/graphql/types/tasks'
import IconCheckmark from 'src/icons/IconCheckmark'
import IconSearch from 'src/icons/IconSearch'
import { formatSnakeValue } from 'src/lib/formatters'

const TaskFilterBar = ({
  selectedTaskTypes,
  setSelectedTaskTypes,
  selectedTaskPriorities,
  setSelectedTaskPriorities,
  selectedStatuses,
  setSelectedStatuses,
  selectedRecruiters,
  setSelectedRecruiters,
  searchText,
  setSearchText,
}) => {
  const { currentUser } = useAuth()
  const recruiters = useContext(RecruitersContext)
  const suggestedEmployeeId = currentUser?.employeeId
  const fullName = `${currentUser?.firstName ?? ''} ${currentUser?.lastName ?? ''}`.trim()

  return (
    <div className="flex flex-row items-center gap-2">
      {suggestedEmployeeId && (
        <div className="flex flex-row items-center gap-2">
          <div className="text-xs font-medium text-doubleNickel-gray-700">
            Suggested:
          </div>
          <Tag
            clickable={true}
            onClick={() => {
              if (selectedRecruiters.includes(suggestedEmployeeId)) {
                setSelectedRecruiters(
                  selectedRecruiters.filter((id) => id !== suggestedEmployeeId)
                )
              } else {
                setSelectedRecruiters([
                  ...selectedRecruiters,
                  suggestedEmployeeId,
                ])
              }
            }}
            showCloseButton={false}
          >
            {selectedRecruiters.includes(suggestedEmployeeId) && (
              <IconCheckmark className="h-3 w-3 fill-none stroke-doubleNickel-brand-400" />
            )}
            {fullName}
          </Tag>
        </div>
      )}
      <TextInput
        className="w-[300px]"
        placeholder="Search tasks by title or description"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        leftSection={
          <IconSearch className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
        }
      />
      <FilterMenu
        filters={[
          {
            title: 'Type',
            selected: selectedTaskTypes,
            onChange: (value) => {
              setSelectedTaskTypes(value)
            },
            options: Object.values(TaskType).map((type) => ({
              value: type,
              label: type.charAt(0).toUpperCase() + type.slice(1).toLowerCase(),
            })),
          },
          {
            title: 'Priority',
            selected: selectedTaskPriorities,
            onChange: (value) => {
              setSelectedTaskPriorities(value)
            },
            options: Object.values(TaskPriority).map((priority) => ({
              value: priority,
              label:
                priority.charAt(0).toUpperCase() +
                priority.slice(1).toLowerCase(),
            })),
            alphabetize: false,
          },
          {
            title: 'Status',
            selected: selectedStatuses,
            onChange: (value) => {
              setSelectedStatuses(value)
            },
            options: Object.values(TaskStatus).map((status) => ({
              value: status,
              label: formatSnakeValue(status),
            })),
            alphabetize: false,
          },
          {
            title: 'Assignee',
            selected: selectedRecruiters,
            onChange: (value) => {
              setSelectedRecruiters(value)
            },
            options: recruiters ? [...recruiters] : [],
          },
        ]}
      />
    </div>
  )
}

export default TaskFilterBar
